import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { addSquadMembers, deleteSquadMembers } from '../redux/actions/game/squad.actions'
import DefaultFrame from '../components/frame/DefaultFrame'
import SquadMonitor from '../components/entity/SquadMonitor'
import RosterMonitor from '../components/entity/RosterMonitor'
import BackLink from '../components/ui/navigation/BackLink'
import { goToUnit } from '../redux/actions/routing/route.actions'
import getSquadFromRoster from '../redux/selectors/getSquadWithEquipment'
import getAvailableUnitsFromRoster from '../redux/selectors/getAvailableUnitsFromRoster'

const Squad = (props) => {
    const {
        squadUnits, rosterUnits, editUnit, addMember, deleteMember,
    } = props

    return (
        <DefaultFrame>
            <div className="scene--base scene__squad">
                <div className="scene--title">
                    <BackLink>
                        <button className="backLink--title" type="button">Back</button>
                    </BackLink>
                    <h1>Squad Page</h1>
                </div>
                <SquadMonitor
                    squadUnits={squadUnits}
                    handleEdit={{ enabled: true, handler: editUnit }}
                    handleDelete={{ enabled: true, handler: deleteMember }}
                />
                <RosterMonitor
                    rosterUnits={rosterUnits}
                    handleEdit={{ enabled: true, handler: editUnit }}
                    handleAdd={{ enabled: true, handler: addMember }}
                />
                <BackLink>
                    <button className="backLink--base" type="button">Back to previous screen</button>
                </BackLink>
            </div>
        </DefaultFrame>
    )
}

Squad.propTypes = {
    squadUnits: PropTypes.array.isRequired,
    rosterUnits: PropTypes.array.isRequired,
    editUnit: PropTypes.func.isRequired,
    addMember: PropTypes.func.isRequired,
    deleteMember: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    squadUnits: getSquadFromRoster(state),
    rosterUnits: getAvailableUnitsFromRoster(state),
})

const mapDispatchToProps = dispatch => ({
    editUnit: unit => dispatch(goToUnit(unit)),
    addMember: unit => dispatch(addSquadMembers([unit])),
    deleteMember: unit => dispatch(deleteSquadMembers([unit])),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Squad)
